export function createAddress(profile, country, translations, short) {
  if (!profile) return ''

  const { ADDRESS_INFO_FIELDS = profile } = profile
  const isUSPanregion = ['US', 'CA'].includes(country.code)

  const addressParts = {
    streetAddress: [],
    city: '',
    district: '',
    area: '',
    postIndex: '',
    country: '',
  }

  Object.keys(ADDRESS_INFO_FIELDS).forEach((value) => {
    if (ADDRESS_INFO_FIELDS[value]) {
      switch (value) {
        case 'STREET': {
          // Убираем HTML из поля STREET, который приходят с бэка
          const streetValue = ADDRESS_INFO_FIELDS[value].replace(
            /<\/?[^>]+(>|$)/g,
            ''
          )
          addressParts.streetAddress.unshift(streetValue)
          break
        }
        case 'BUILD':
          if (ADDRESS_INFO_FIELDS[value] !== '0') {
            addressParts.streetAddress.push(ADDRESS_INFO_FIELDS[value])
          }
          break
        case 'METRO':
          addressParts.streetAddress.push(ADDRESS_INFO_FIELDS.METRO)
          break
        // PL кейс вместо STREET
        case 'ADDRESS':
          addressParts.streetAddress.push(ADDRESS_INFO_FIELDS.ADDRESS)
          break
        // PL кейс вместо BUILD
        case 'BUILD_APART_NUM':
          addressParts.streetAddress.push(ADDRESS_INFO_FIELDS.BUILD_APART_NUM)
          break

        case 'CORPUS':
          addressParts.streetAddress.push(
            `${translations('CHECKOUT_ADDRESS_INFO_FIELDS_KORPUS')} ${ADDRESS_INFO_FIELDS[value]}`
          )
          break
        case 'APARTMENT':
          if (ADDRESS_INFO_FIELDS[value] !== '0') {
            addressParts.streetAddress.push(
              `${translations('CHECKOUT_ADDRESS_INFO_FIELDS_APARTMENT')} ${ADDRESS_INFO_FIELDS[value]}`
            )
          }
          break
        case 'ENTRANCE':
          addressParts.streetAddress.push(
            `${translations('CHECKOUT_ADDRESS_INFO_FIELDS_ENTRANCE')} ${ADDRESS_INFO_FIELDS[value]}`
          )
          break
        case 'INTERCOM':
          addressParts.streetAddress.push(
            `${translations('CHECKOUT_ADDRESS_INFO_FIELDS_INTERCOM')} ${ADDRESS_INFO_FIELDS[value]}`
          )
          break
        case 'FLOOR':
          addressParts.streetAddress.push(
            `${translations('CHECKOUT_ADDRESS_INFO_FIELDS_FLOOR')} ${ADDRESS_INFO_FIELDS[value]}`
          )
          break
        case 'CITY':
          addressParts.city = ADDRESS_INFO_FIELDS.CITY
          break
        case 'DISTRICT':
          addressParts.district = ADDRESS_INFO_FIELDS.DISTRICT
          break
        case 'AREA':
          addressParts.area = ADDRESS_INFO_FIELDS.AREA
          break
        case 'POSTINDEX':
          addressParts.postIndex = ADDRESS_INFO_FIELDS.POSTINDEX
          break
        case 'COUNTRY':
          if (!short) addressParts.country = country.name
          break
        default:
          break
      }
    }
  })

  if (addressParts.city === addressParts.area) {
    addressParts.area = ''
  }

  const streetAddress = addressParts.streetAddress.join(', ')

  // 1230 Six Flags Rd, Austell, GA 30168, США
  let formattedUSA = ''
  if (ADDRESS_INFO_FIELDS.BUILD) formattedUSA += `${ADDRESS_INFO_FIELDS.BUILD} `
  if (ADDRESS_INFO_FIELDS.STREET)
    formattedUSA += `${ADDRESS_INFO_FIELDS.STREET}, `
  if (ADDRESS_INFO_FIELDS.APARTMENT)
    formattedUSA += `${ADDRESS_INFO_FIELDS.APARTMENT}, `
  if (ADDRESS_INFO_FIELDS.CITY) formattedUSA += `${ADDRESS_INFO_FIELDS.CITY}, `
  if (ADDRESS_INFO_FIELDS.AREA) formattedUSA += `${ADDRESS_INFO_FIELDS.AREA} `
  if (ADDRESS_INFO_FIELDS.POSTINDEX)
    formattedUSA += `${ADDRESS_INFO_FIELDS.POSTINDEX}`

  const finalAddress = isUSPanregion
    ? formattedUSA
    : [
        streetAddress,
        addressParts.city,
        addressParts.district,
        addressParts.area,
        addressParts.country,
        addressParts.postIndex,
      ]
        .filter(Boolean)
        .join(', ')

  return finalAddress
}

/**
 * Создает строку адреса из дополнительных полей (ADDITIONAL_INFO_FIELDS)
 * @param {Object} profile - профиль доставки
 * @returns {string} - форматированный адрес фактуры
 */
export function createAdditionalAddress(profile) {
  if (!profile?.ADDITIONAL_INFO_FIELDS) return ''

  const fields = profile.ADDITIONAL_INFO_FIELDS

  // Собираем все поля в нужном порядке
  const addressParts = [
    fields.FAKTURA_ADDRESS,
    fields.FAKTURA_POSTINDEX,
    fields.FAKTURA_CITY,
  ]

  // Фильтруем пустые значения и объединяем через запятую с пробелом
  const result = addressParts.filter((part) => part && part !== '').join(', ')

  return result
}

export function formattedUSA(profile, area) {
  // 1230 Six Flags Rd, Austell, GA 30168, США
  let formatted = ''

  if (profile?.BUILD) {
    formatted += `${profile.BUILD} `
  }
  if (profile?.STREET) {
    formatted += `${profile.STREET}, `
  }
  if (profile?.CITY) {
    formatted += `${profile.CITY}, `
  }
  const areaName = area && area.short_name ? area.short_name : profile.AREA
  if (areaName) {
    formatted += `${areaName} `
  }
  if (profile?.POSTINDEX) {
    formatted += `${profile.POSTINDEX}`
  }

  return formatted.trim()
}
